/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'facebook-sm': {
    width: 163.839,
    height: 163.839,
    viewBox: '0 0 258 258',
    data: '<rect pid="0" height="258" rx="28" ry="28" width="258" _fill="#3b5999"/><path pid="1" d="M84 106h27v-5c0-8-1-18 0-26 1-19 11-31 37-32l26 1v28c-11 0-30-4-32 10v24h30l-3 31h-27v78h-31v-78l-27-1v-30z" _fill="#fff"/><path pid="2" d="M258 128l-84-84v28c-11 0-30-4-32 10v24h30l-3 31h-27v78h-31l43 43h76l28-28V128z" _fill="#30487c"/>'
  }
})
